import gql from 'graphql-tag';

export const INITIATE_PARTNER_AUTHENTICATION = gql`
  mutation MutationInitiatePartnerAuthentication($emailAddress: String!) {
    PartnerHubMutations {
      initiatePartnerAuthentication(emailAddress: $emailAddress) {
        __typename
        message
        properties {
          id
          location {
            __typename
            name
          }
          name
          address {
            __typename
            address
            postalCode
          }
          supplierName
        }
      }

    }
  }

`;

export const HAS_PROPERTY_MIGRATED = gql`
  query HasPropertyMigrated($emailAddress: String!){
    PartnerHubQueries {
      hasPropertyMigrated(emailAddress: $emailAddress)
    } 
  }
`